import { render, staticRenderFns } from "./ChargeBack.vue?vue&type=template&id=db067050"
import script from "./ChargeBack.vue?vue&type=script&lang=js"
export * from "./ChargeBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports